import React from 'react';
import { certifications } from '../data/mock';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Award } from 'lucide-react';

const Certifications = () => {
  return (
    <section className="py-20 px-6 bg-muted/30">
      <div className="container mx-auto max-w-4xl">
        <div className="space-y-4 mb-12">
          <h2 className="text-sm font-mono text-cyan-500 uppercase tracking-wider">
            Verified credentials
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold">Certifications</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {certifications.map((cert, index) => (
            <Card key={index} className="p-6 hover:border-cyan-500/50 transition-all">
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="h-12 w-12 rounded-lg bg-cyan-500/10 flex items-center justify-center">
                    <Award className="h-6 w-6 text-cyan-500" />
                  </div>
                </div>
                <div className="space-y-1">
                  <p className="text-sm text-muted-foreground">{cert.issuer}</p>
                  <h4 className="font-semibold">{cert.title}</h4>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
